export default __webpack_public_path__ + "static/media/Leggings.13eb5e93.png";